import React from 'react';
import Table from '../table';
import { SortConfig, TableColumn } from './types';

interface ReportTableProps {
  data: any[];
  columns: TableColumn[];
  onSort: (key: string, direction: 'asc' | 'desc' | null) => void;
  sortConfig: SortConfig;
  onRowClick?: (item: any) => void;
}

const ReportTable: React.FC<ReportTableProps> = ({ data, columns, onSort, sortConfig, onRowClick }) => {
  return (
    <div id="report-table-container" className="report-table-wrapper">
      <Table
        columns={columns}
        data={data}
        onSort={onSort}
        sortConfig={sortConfig}
        onRowClick={onRowClick}
        makeRowClickable={!!onRowClick}
      />
    </div>
  );
};

export default ReportTable;
